// @flow

import React, {useRef, useState} from "react";
import {Col, Input} from "antd";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {CompanyContanier, FilterContainer, MergeOptionsWrapper, FilterWrapper} from "../optionsStyles";
import CompanyShiftOptions from "./Options";
import SubCompanyShiftOptions from "./SubCompanyShiftOptions/SubCompanyShiftOptions";
import {CityFilter} from "../../../_defaultComponents/FilterComponents";

const ShiftOptions = ({companyId}) => {
    const stores = useStore();
    const {t} = useTranslation();

    const [currentPage, setCurrentPage] = useState(1);
    const [city, setCity] = useState("all");
    const [searchText, setSearchText] = useState("");
    const [text, setText] = useState("");
    const [companyRecall, setCompanyRecall] = useState(false);
    const [subCompanyRecall, setSubCompanyRecall] = useState(false);

    const companyRecallRef = useRef(companyRecall);
    companyRecallRef.current = companyRecall;
    const subCompanyRecallRef = useRef(subCompanyRecall);
    subCompanyRecallRef.current = subCompanyRecall;

    const [companyLoading, companyData, setCompanyData, setCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.companyStore.getCompany.bind(null, {
            companyId,
            withSubCompanies: false,
            vehicleType: null
        }),
        dependencies: [companyRecall]
    });

    const [subCompanyLoading, subCompanyData, setSubCompanyData, setSubCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn:
            companyData.data && companyData.data._id
                ? stores.companyStore.getSubCompanyList.bind(null, {
                      companyId: companyData.data._id,
                      limit: 10,
                      skip: (currentPage - 1) * 10,
                      activity: "enabled",
                      vehicleType: null,
                      city,
                      searchText
                  })
                : () => [],
        dependencies: [companyData, currentPage, subCompanyRecall, city, searchText]
    });

    return (
        <MergeOptionsWrapper data-testid="appointmentOptionsFilter">
            <h2 data-testid="companyName">{companyData?.data?.companyName}</h2>
            <CompanyContanier>
                <CompanyShiftOptions
                    companyLoading={companyLoading}
                    setCompanyLoading={setCompanyLoading}
                    companyData={companyData}
                    searchText={searchText}
                    city={city}
                    setSubCompanyRecall={setSubCompanyRecall}
                    setCompanyRecall={setCompanyRecall}
                    companyRecallRef={companyRecallRef}
                    subCompanyRecallRef={subCompanyRecallRef}
                />
            </CompanyContanier>
            <FilterWrapper>
                <Col span={12} data-testid="filterCard">
                    <FilterContainer type="flex" gutter={[20, 20]}>
                        <Col span={6}>
                            <CityFilter
                                value={city}
                                onChange={value => {
                                    setCurrentPage(1);
                                    setCity(value);
                                }}
                            />
                        </Col>
                        <Col span={6}>
                            <h5>{t("filters.search", {ns: "common"})}</h5>
                            <Input.Search
                                value={text}
                                data-testid="searchInput"
                                onSearch={value => {
                                    setCurrentPage(1);
                                    setSearchText(value);
                                }}
                                onChange={event => {
                                    setText(event.target.value);
                                }}
                            ></Input.Search>
                        </Col>
                    </FilterContainer>
                </Col>
            </FilterWrapper>
            <SubCompanyShiftOptions
                subCompanyData={subCompanyData}
                subCompanyLoading={subCompanyLoading}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                companyId={companyId}
                subCompanyRecallRef={subCompanyRecallRef}
                setSubCompanyRecall={setSubCompanyRecall}
                setSubCompanyData={setSubCompanyData}
            />
        </MergeOptionsWrapper>
    );
};

export default ShiftOptions;
